import React from 'react';
import { Shirt, BookOpen, Sparkles, Heart } from 'lucide-react';
const categories = [{
  name: 'Apparel',
  icon: Shirt,
  description: 'Custom t-shirts, hoodies, and apparel for every occasion. Quality designs that last.',
  link: '/products?category=apparel'
}, {
  name: 'Bookish',
  icon: BookOpen,
  description: 'Book-themed accessories and gifts for readers. Perfect for book lovers and literary enthusiasts.',
  link: '/products?category=bookish'
}, {
  name: 'Freshies',
  icon: Sparkles,
  description: 'Car fresheners in custom scents and designs. Keep your ride smelling fresh with style.',
  link: '/products?category=freshies'
}, {
  name: 'Fundraisers',
  icon: Heart,
  description: 'Fundraising products for schools, teams, and organizations. Easy ordering, great margins.',
  link: '/products?category=fundraisers'
}];
export function ProductCategories() {
  const backgroundPattern = `data:image/svg+xml,%3Csvg width='200' height='200' xmlns='http://www.w3.org/2000/svg'%3E%3Cdefs%3E%3Cstyle%3E .icon %7B fill: none; stroke-width: 1.5; opacity: 0.08; %7D .purple %7B stroke: %239333ea; %7D .teal %7B stroke: %2314b8a6; %7D %3C/style%3E%3C/defs%3E%3Cg%3E%3Cpath class='icon purple' d='M30 40 L30 60 L50 65 L70 60 L70 40 L50 35 Z M35 45 L35 55 M65 45 L65 55'/%3E%3Ccircle class='icon teal' cx='150' cy='50' r='15'/%3E%3Cpath class='icon teal' d='M135 50 Q135 35 150 35 Q165 35 165 50'/%3E%3Cpath class='icon purple' d='M50 130 L50 160 M40 140 L60 140 M45 150 L55 150'/%3E%3Crect class='icon teal' x='130' y='130' width='30' height='35' rx='3'/%3E%3Cpath class='icon teal' d='M135 130 Q145 125 155 130'/%3E%3Cpath class='icon purple' d='M180 140 L190 135 L195 145 L185 150 Z M187 142 L188 143'/%3E%3C/g%3E%3C/svg%3E`;
  return <section id="products" className="py-20 bg-gray-50 relative overflow-hidden" style={{
    backgroundImage: `url("${backgroundPattern}")`,
    backgroundSize: '200px 200px',
    backgroundPosition: 'center'
  }} data-id="element-208">
      {/* Radial gradient overlay to make center lighter */}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse at center, rgba(249, 250, 251, 0.7) 0%, rgba(249, 250, 251, 0.2) 70%, transparent 100%)'
    }} data-id="element-209"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-210">
        <div className="text-center mb-16" data-id="element-211">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-212">
            Shop Pre-Designed Products
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-213">
            Browse our curated collection of pre-designed apparel, book-themed
            items, car fresheners, and fundraising products.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto" data-id="element-214">
          {categories.map(category => <a key={category.name} href={category.link} className="group bg-white rounded-xl p-8 shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-100 hover:border-teal-200" data-id="element-215">
              <div className="h-14 w-14 bg-teal-50 rounded-xl flex items-center justify-center text-teal-600 mb-6 group-hover:bg-teal-500 group-hover:text-white transition-colors" data-id="element-216">
                <category.icon className="h-7 w-7" data-id="element-217" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors" data-id="element-218">
                {category.name}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-219">
                {category.description}
              </p>
            </a>)}
        </div>

        <div className="mt-12 text-center" data-id="element-220">
          <a href="/products" className="inline-flex items-center justify-center px-8 py-4 bg-purple-600 hover:bg-purple-700 text-white text-lg font-medium rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1" data-id="element-221">
            View All Products
          </a>
        </div>
      </div>
    </section>;
}